import type { TJSONSchema } from "@artifact-management/json-dynamic-form";
import { AutocompleteStructurePartners } from "@inputs/autocomplete/AutocompleteStructurePartners";
import { type FieldValues, type Path, type PathValue, useController } from "react-hook-form";
import type { IFormGenInputProps } from "./index";

export const FormGenInputStructurePartner = <Schema extends TJSONSchema, T extends FieldValues>({
  control,
  uiSchemaElement,
}: IFormGenInputProps<Schema, T>) => {
  const { field, fieldState } = useController({
    control,
    name: uiSchemaElement.scope as unknown as Path<T>,
    defaultValue: null as PathValue<T, Path<T>>,
  });

  return (
    <AutocompleteStructurePartners
      value={field.value}
      size="small"
      onChange={(_, option) => field.onChange(option)}
      onBlur={field.onBlur}
      TextFieldProps={{
        label: uiSchemaElement.label,
        error: Boolean(fieldState.error),
        helperText: fieldState.error?.message,
      }}
    />
  );
};
